import type { Columns } from '@/types/table';

export const ORDER_ERROR_COLUMNS: Columns[] = [
  {
    name: 'Services',
    selector: 'services',
    width: '340px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'Property Type',
    selector: 'propertyType',
    width: '200px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'Address',
    selector: 'address',
    width: '300px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'Unit Number',
    selector: 'unitNumber',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'City',
    selector: 'city',
    width: '220px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'State',
    selector: 'state',
    width: '200px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'Zip Code',
    selector: 'zipCode',
    width: '200px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'On-Site Contact Name',
    selector: 'onsiteContactName',
    width: '240px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'On-Site Contact Phone',
    selector: 'onsiteContactPhone',
    width: '210px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'Access Type',
    selector: 'accessType',
    width: '240px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'Lockbox Location',
    selector: 'lockboxLocation',
    width: '280px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'Access Code',
    selector: 'accessCode',
    width: '200px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'Rently Registration PIN',
    selector: 'rentlyRegistrationPin',
    width: '210px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'Order Notes',
    selector: 'orderNotes',
    width: '320px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Gate Code',
    selector: 'gateCode',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Schedule Later Date',
    selector: 'firstAvailableDate',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Property ID',
    selector: 'propertyId',
    width: '240px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Beds',
    selector: 'beds',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Baths',
    selector: 'baths',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Square Feet',
    selector: 'squareFeet',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
  {
    name: 'Entity ID',
    selector: 'entity',
    width: '260px',
    type: 'component',
    isSort: true,
    isMandatory: true,
    isSortableByHeader: false,
  },
  {
    name: 'Previous Order ID',
    selector: 'previousOrderId',
    width: '200px',
    type: 'component',
    isSort: true,
    isSortableByHeader: false,
  },
];
